import React, { Fragment, useState, useRef } from 'react';
import Progress from './Progress';
import axios from 'axios';
import {ServerConfig} from 'config'
import { useDispatch } from 'react-redux';
import {
  ALERT_SUCCESS,
  ALERT_FAIL,
  ALERT_WARNING,
} from '../../redux/actions/types.js';

import {
    Button,
    Grid,
    Snackbar
  } from '@material-ui/core';

const FileUpload = (props) => {
  const dispatch = useDispatch();
  const {uploadUrl, currentUrl, token, onChangeCallback, accept_types, extraFormData = {}, checkCsvDuplicates = false} = props;

  const [file, setFile] = useState('');

  const [filename, setFilename] = useState(props.currentUrl);
  const [uploadedFile, setUploadedFile] = useState(props.currentUrl);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

  const onChange = e => {
    setFile(e.target.files[0]);
    setFilename(e.target.files[0].name);
  };

  const checkForDuplicates = async () => {
    if (!file) {
      showAlert('Please choose a CSV file first', 'warning');
      return;
    }

    try {
      const text = await file.text();

      const lines = text
        .split(/\r?\n/)
        .filter((line) => line.trim() !== '');

      if (lines.length <= 1) {
        showAlert('No data rows found in CSV', 'warning');
        return;
      }

      const seen = new Map();
      const duplicates = [];

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(';');

        if (values.length !== 2) {
          showAlert(`Invalid CSV format on line ${i + 1}`, 'error');
          return;
        }

        const stickerCode = values[1].trim().toLowerCase();

        if (!stickerCode) {
          continue;
        }

        if (seen.has(stickerCode)) {
          duplicates.push({
            stickerCode,
            firstLine: seen.get(stickerCode),
            duplicateLine: i + 1,
          });
        } else {
          seen.set(stickerCode, i + 1);
        }
      }

      if (duplicates.length > 0) {
        const duplicateText = duplicates
          .map(
            (dup) =>
              `${dup.stickerCode} (lines ${dup.firstLine} and ${dup.duplicateLine})`
          )
          .join(', ');

        showAlert(`Duplicates found: ${duplicateText}`, 'error');
        return;
      }

      showAlert('No duplicate sticker codes found', 'success');
    } catch (err) {
      console.log(err);
      showAlert('Could not read CSV file', 'error');
    }
  };

  const fileInput = useRef(null)

  const onSubmit = async e => {
    e.preventDefault();
    setShowProgressBar(true);

    const formData = new FormData();
    formData.append('file', file);
    console.log("FOR: ", formData);

    Object.entries(extraFormData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });

    try {
      {/* const url = `${ServerConfig.SERVER_URL}/blog/UploadImage`; */}
      const url = `${ServerConfig.SERVER_URL}${uploadUrl}`;
      console.log("========= URL: "+ url);

      const res = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':`Bearer ${token}`
        },
        onUploadProgress: progressEvent => {
          setUploadPercentage(
            parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            )
          );
        }
      });
      
      // Clear percentage
      setTimeout(() => setUploadPercentage(0), 10000);

      setUploadedFile(res.data.location);
      setShowProgressBar(false);

      onChangeCallback(res.data.location);
    } catch (err) {
      console.log(err);

      let errorMessage = 'File upload failed';

      if (err.response?.status === 500) {
        errorMessage = 'There was a problem with the server';
      } else if (err.response?.data?.msg) {
        errorMessage = err.response.data.msg;
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      showAlert(errorMessage, 'error');

      setUploadPercentage(0);
      setShowProgressBar(false);
    }
  };

  const showAlert = (message, type = 'success') => {
    let actionType = ALERT_SUCCESS;

    if (type === 'error') {
      actionType = ALERT_FAIL;
    } else if (type === 'warning') {
      actionType = ALERT_WARNING;
    }

    dispatch({
      type: actionType,
      payload: message,
    });
  };
  return (
    <>
      <form onSubmit={onSubmit}>
      <Grid container spacing={2}>
          <Grid item xs={6}>
            <div className='custom-file mb-4'>
            <input
                type='file'
                className='custom-file-input'
                id='customFile'
                accept={accept_types}
                onChange={onChange}
                ref={fileInput}
                style={{display:'none'}}
            />
            <Button onClick={() => fileInput.current.click()}>Choose File</Button>
            <label className='custom-file-label' htmlFor='customFile' style={{marginLeft:'10px'}}>
                {filename}
            </label>
            </div>
            </Grid>
        
            {checkCsvDuplicates && (
              <Grid item xs={3}>
                <Button
                  type="button"
                  onClick={checkForDuplicates}
                  disabled={!file}
                >
                  Check for Duplicates
                </Button>
              </Grid>
            )}
            <Grid item xs={3}>
              <Button
                type="submit"
                value="Upload"
                disabled={!file}
              >
                Upload
              </Button>
            </Grid>

            {showProgressBar &&
                <Grid item xs={12}>
                    <Progress percentage={uploadPercentage} />
                </Grid>
            }
        </Grid>
      </form>
    </>
  );
};

export default FileUpload;
